// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IUndeliverableAddressBriefRecordDto
 */
export interface IUndeliverableAddressBriefRecordDto {
    /**
     * 
     * @type {number}
     * @memberof IUndeliverableAddressBriefRecordDto
     */
    flagged_employees_count?: number;
}

/**
 * Check if a given object implements the IUndeliverableAddressBriefRecordDto interface.
 */
export function instanceOfIUndeliverableAddressBriefRecordDto(value: object): value is IUndeliverableAddressBriefRecordDto {
    return true;
}

export function IUndeliverableAddressBriefRecordDtoFromJSON(json: any): IUndeliverableAddressBriefRecordDto {
    return IUndeliverableAddressBriefRecordDtoFromJSONTyped(json, false);
}

export function IUndeliverableAddressBriefRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IUndeliverableAddressBriefRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'flagged_employees_count': json['flagged_employees_count'] == null ? undefined : json['flagged_employees_count'],
    };
}

export function IUndeliverableAddressBriefRecordDtoToJSON(json: any): IUndeliverableAddressBriefRecordDto {
    return IUndeliverableAddressBriefRecordDtoToJSONTyped(json, false);
}

export function IUndeliverableAddressBriefRecordDtoToJSONTyped(value?: IUndeliverableAddressBriefRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'flagged_employees_count': value['flagged_employees_count'],
    };
}

